import { render, staticRenderFns } from "./MenuIntegracao.vue?vue&type=template&id=742a1c9c&scoped=true"
import script from "./MenuIntegracao.vue?vue&type=script&lang=js"
export * from "./MenuIntegracao.vue?vue&type=script&lang=js"
import style0 from "./MenuIntegracao.vue?vue&type=style&index=0&id=742a1c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a1c9c",
  null
  
)

export default component.exports